// Only one item MUST have the "default: true" key

module.exports = {
  it: {
    default: true,
    path: `it`,
    locale: `it-IT`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `it`,
    ogLanguage: `it_IT`,
    defaultTitle: `Residence Hotel Paradiso`,
    defaultDescription: `Residence Hotel Paradiso - Family and Sport Hotel`,
  },
  en: {
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    defaultTitle: `Residence Hotel Paradiso`,
    defaultDescription: `Residence Hotel Paradiso - Family and Sport Hotel`,
  },
  de: {
    path: `de`,
    locale: `de-DE`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `de`,
    ogLanguage: `de_DE`,
    defaultTitle: `Residence Hotel Paradiso`,
    defaultDescription: `Residence Hotel Paradiso - Family and Sport Hotel`,
  },
  fr: {
    path: `fr`,
    locale: `fr-FR`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `fr`,
    ogLanguage: `fr_FR`,
    defaultTitle: `Residence Hotel Paradiso`,
    defaultDescription: `Residence Hotel Paradiso - Family and Sport Hotel`,
  },
}
